// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PartDropDownMenu_wrapper__sq6g_","menu":"PartDropDownMenu_menu__EuJtD","menuItem":"PartDropDownMenu_menuItem__1OfNW"};